module.exports = __webpack_public_path__ + "img/app-4-on.8a83ca31.png";